/**
* @ngdoc directive
* @name Tab Input
*
* @description
  Input with label on top, help text at the bottom and checkmark on right when updated
*
* @scope
* @param {Boolean} isInvalid - show error
* @param {Boolean} isDisabled - disable
* @param {Boolean} isUpdated - show checkmark
* @param {String} label - shown on top of input, used as placeholder if not provided in input
* @param {String} message - message to show at the bottom
*
* @example
  <div ng-init='name="Whaaaat"'>
    <tab-input is-invalid='!name' label='User Name' message='"i am message"'>
      <input type="text" class="form-control"
        ng-model="name"
        maxlength="100"
        required
        />
    </tab-input>
    <tab-input is-disabled="'true'" label='User Name'>
      <input type="text" class="form-control"
        ng-model="name"
        maxlength="100"
        required
        />
    </tab-input>
    <tab-input is-updated="'true'" label='User Name'>
      <input type="text" class="form-control"
        ng-model="name"
        maxlength="100"
        required
        />
    </tab-input>
  </div>
*/

app.directive('tabInput', ["PATH", "$timeout", function(PATH, $timeout) {
  return {
    restrict: 'E',
    transclude: true,
    templateUrl: PATH.components + 'tabInput/template.html',
    scope: {
      isInvalid: '=?',
      isDisabled: '=?',
      isUpdated: '=?',
      label: '@?',
      message: '=?'
    },
    link: function ($scope, $element) {
      // wait for directives in ng-transclude to be rendered
      $timeout(function () {
        var input = $element.find('input');
        if (!input.length) input = $element.find('select');

        if ($scope.label && !input.attr('placeholder')) {
          input.attr('placeholder', $scope.label);
        }

        $scope.$watch('isDisabled', function (value) {
          input.attr('disabled', !!value);
        });

        input.bind('focus', onFocus);

        function onFocus() {
          $element.find('.tab-input').addClass('mod-focused');
          input.bind('blur', onBlur);
          input.unbind('focus', onFocus);
        }

        function onBlur() {
          $element.find('.tab-input').removeClass('mod-focused');
          input.bind('focus', onFocus);
          input.unbind('blur', onBlur);
        }
      }, 0);
    }
  };
}]);



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/tabInput/directive.js